export default {
      id: "team-members-usage",
      viewBox: "0 0 28 28",
      url: "/" + "images/icons.3.109.2.svg#team-members-usage",
      toString: function () {
        return this.url;
      }
    }